module.exports = __webpack_public_path__ + "static/media/ana-sofia.0ca279d2.bin";